import { useEffect } from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqItems = [
  {
    question: "Comment sont calculés nos honoraires ?",
    answer: "Si nous vous proposons des honoraires très compétitifs c'est que nous avons décidé de ne pas avoir d'agence physique, de dématérialiser au maximum les tâches peu créatrices de valeur et de nous appuyer sur des outils d'IA pour nous faire gagner du temps."
  },
  {
    question: "Travaillez-vous avec les expatriés ?",
    answer: "Oui, nous accompagnons régulièrement des clients basés à l'étranger. Nous disposons de partenaires juristes, fiscalistes et notaires spécialisés dans les transactions immobilières internationales qui sauront vous accompagner dans toutes les spécificités de votre projet."
  },
  {
    question: "Puis-je vendre mon bien avec vous ?",
    answer: "Oui, et c'est même un réel avantage pour un projet global. Nous pouvons parfaitement synchroniser l'organisation de la vente et de l'achat, tant en termes de financement que de timing, pour sécuriser votre opération dans son ensemble. Cette approche coordonnée vous permet d'optimiser chaque étape et de bénéficier d'une vision stratégique complète de votre projet."
  },
  {
    question: "Comment se passe notre premier échange ?",
    answer: "Nous commençons par un appel ou une rencontre pour comprendre votre projet, vos critères et votre budget. Cet échange est gratuit et sans engagement. Il nous permet de bien cerner vos attentes et de vous expliquer notre approche et notre méthodologie."
  },
  {
    question: "Quelles zones géographiques couvrez-vous ?",
    answer: "Nous intervenons principalement à Paris et le Grand Paris."
  }
];

export const FAQPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div data-testid="faq-page" className="pt-32">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-gold text-sm font-bold uppercase tracking-[0.2em] mb-4">
              Questions fréquentes
            </p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
              FAQ
            </h1>
            <p className="text-text-secondary text-lg">
              Retrouvez les réponses aux questions les plus fréquentes sur nos services
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section data-testid="faq-section" className="py-16 md:py-24 bg-surface">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <AccordionItem
                  value={`item-${index}`}
                  data-testid={`faq-item-${index}`}
                  className="bg-background border border-line px-6"
                >
                  <AccordionTrigger className="text-text-primary font-bold text-left hover:text-gold transition-colors py-6">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-text-secondary pb-6">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};
